import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App.tsx'
import './index.css'

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string

// 2026-04-24: bootstrap is gated on auth completion (in App.tsx → AppShell).
// Doing it here would fire before login and just get 401. main.tsx stays
// simple to avoid the bootstrap race that previously broke the dashboard.
//
// 2026-04-26: dropped <React.StrictMode>. Every API call was firing exactly
// twice on cold load — the canonical StrictMode signature. Even though
// React docs claim StrictMode is a no-op in production, in our vite + React
// 18 build the double-effect behavior was leaking through and burning
// ~20 unnecessary REST calls per session start. Re-enable for local dev
// (vite dev server) if you need the strict-mode warnings.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <App />
  </GoogleOAuthProvider>,
)
